import { TextField } from "@mui/material";

const Input = (props: any) => <TextField variant="outlined" style={{margin: '0 0.5rem'}} {...props}/>

export default Input;